var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1678_10455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.08398 1.79159C4.08398 1.677 4.17773 1.58325 4.29232 1.58325H6.37565C6.49023 1.58325 6.58398 1.677 6.58398 1.79159V3.66659H4.08398V1.79159ZM8.66732 3.66659H7.83398V1.79159C7.83398 0.986898 7.18034 0.333252 6.37565 0.333252H4.29232C3.48763 0.333252 2.83398 0.986898 2.83398 1.79159V3.66659H2.00065C1.08138 3.66659 0.333984 4.41398 0.333984 5.33325V11.1666C0.333984 12.0859 1.08138 12.8333 2.00065 12.8333C2.00065 13.2942 2.37305 13.6666 2.83398 13.6666C3.29492 13.6666 3.66732 13.2942 3.66732 12.8333H7.00065C7.00065 13.2942 7.37305 13.6666 7.83398 13.6666C8.29492 13.6666 8.66732 13.2942 8.66732 12.8333C9.58659 12.8333 10.334 12.0859 10.334 11.1666V5.33325C10.334 4.41398 9.58659 3.66659 8.66732 3.66659ZM3.25065 6.16659H7.41732C7.64648 6.16659 7.83398 6.35409 7.83398 6.58325C7.83398 6.81242 7.64648 6.99992 7.41732 6.99992H3.25065C3.02148 6.99992 2.83398 6.81242 2.83398 6.58325C2.83398 6.35409 3.02148 6.16659 3.25065 6.16659ZM3.25065 9.49992H7.41732C7.64648 9.49992 7.83398 9.68742 7.83398 9.91659C7.83398 10.1458 7.64648 10.3333 7.41732 10.3333H3.25065C3.02148 10.3333 2.83398 10.1458 2.83398 9.91659C2.83398 9.68742 3.02148 9.49992 3.25065 9.49992Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_10455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 13.3333,
    fill: "white",
    transform: "translate(0.333984 0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.2a0da13791df3bf5f59375011bf19ed1.svg";
export { ForwardRef as ReactComponent };